
export default function NoData({ message = "No data" }) {
    return (
        <div className="Tile-body-message">
            <p className="lead">{message}</p>
        </div>
    );
};
